<template>
  <v-container
    class="pa-0"
    :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
  >
    <h1 class="px-4">
      {{ $t('market.horse_about.header1') }}
    </h1>
    <div class="cricket">
      <h2 class="pa-4 pb-0">{{ $t('market.horse_about.header2') }}:</h2>
      <v-card-text>
        <div class="mb-2" v-html="$t('market.horse_about.p1')"></div>
        <div class="mb-2" v-html="$t('market.horse_about.p2')"></div>
        <div class="mb-2">
          {{ $t('market.horse_about.p3') }}
        </div>
      </v-card-text>
    </div>

    <v-divider></v-divider>

    <div class="match-winner">
      <h2 class="pa-4 pb-0">{{ $t('market.cricket_about.header3') }}:</h2>
      <v-card-text>
        <!-- v-for="item in matchWinner" :key="item.title" -->
        <v-row no-gutters>
          <v-col cols="12" md="6">
            <div>
              <!-- v-for="item in item.paras" :key="item.para" -->
              <v-card-text class="pa-0 mb-2">
                <!-- v-html="item.para" -->
                {{ $t('market.cricket_about.p3') }}
              </v-card-text>
              <v-card-text class="pa-0 mb-2">
                {{ $t('market.cricket_about.p4') }}
              </v-card-text>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <v-img
              :src="`${CDN_IMG_URL}/market-inside/horse-racing-odds.png`"
              :lazy-src="`${CDN_IMG_URL}/market-inside/horse-racing-odds.png`"
              contain
              class="mx-auto"
              max-height="200"
              alt="horse racing odds"
            ></v-img>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      CDN_IMG_URL: process.env.CDN_IMG_URL
    }
  }
}
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
  font-weight: bold;
}
</style>
